import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const MakeWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  grid-auto-rows: minmax(100px, auto);
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    margin-right: 4px;
  }
`;

export const MakeContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  min-width: 98px;
  min-height: 88px;
  padding: 8px 8px 7px 8px;
  flex-direction: column;
  gap: 7px;
  border-radius: 12px;
  border: 1px solid var(--Purple-P50, #efe9fb);
  background: var(--Surface-White, #fff);
  ${(props: { selected: any }) =>
    props.selected &&
    `
    border: 1px solid var(--button-default-g-300, #0FA457);
  `}

  @media(max-width: 768px) {
    width: auto;
  }
`;

export const ScrollBox = styled.div`
  max-height: 40vh;
  overflow-y: scroll;
  // padding-right: 20px;
  ${(props: { styles: any }) => ({ ...props.styles })}
  @media (max-width: 768px) {
    max-height: 60vh;
    min-height: 60vh;
    padding-right: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    right: 16px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e7e7f0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #d0d3db;
  }

  ::-webkit-scrollbar-track {
    background-color: #f7f8fa;
    border-radius: 10px;
  }

  scrollbar-width: thin;
  scrollbar-color: #e7e7f0 #f7f8fa;
`;

export const MakeTextContainer = styled.div`
  font-family: "Euclid Circular B";
  text-align: center;
  color: #040222;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const MakeImageContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  // width: 82px;
  min-height: 48px;
  padding: 8px 24.987px;
  justify-content: center;
  align-items: center;
  padding: 8px 19.667px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f9f6ff;
  ${(props: { selected: any }) =>
    props.selected &&
    `
    background: #EBFBEE;
  `}
`;

export const MakeModelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModelContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 32px 16px 0px;
  justify-content: center;
  align-items: left;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 90%;
  }
  @media (min-width: 768px) {
    min-width: 400px;
  }
`;

export const ModelWrapper = styled.div`
  :not(:last-child) {
    border-bottom: 1px solid #e7e7f0;
  }
`;

export const RadioIconContainer = styled.div`
  position: absolute;
  right: -32px;
`;


export const ModelTextContainer = styled(Text)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #040222;
  ${(props: { selected: any }) =>
    props.selected &&
    `
    font-weight: 600;
  `}
`;

export const Seperator = styled.div`
  border-bottom: 1px solid #e7e7f0;
  width: 100%;
`;

export const RegistartionYearContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 32px 16px 0px;
  justify-content: center;
  align-items: left;
  width: 400px;
  cursor: pointer;
`;

export const RegistartionYearWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FuelTypeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FuelTypeItem = styled.div`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-8px, 8px);
  border-radius: 24px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: var(--Surface-White, #fff);
  cursor: pointer;
  ${(props: { selected: any }) =>
    props.selected &&
    `
    background: #040222
    color: #fff;
  `}
`;

export const MmvInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    ${(props: { isVariantSheet: any }) =>
      props.isVariantSheet
        ? `
      height: 50vh;
    `
        : `margin-bottom: 1.75rem;`};
  }

  ${(props: { styles: any }) => props.styles}
`;

export const InfotextContainer = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid #efe9fb;
  background: #f9f6ff;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const InfoIconContainer = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 2.667px 4.053px 2.167px 4.667px;
  height: 48px;
  width: 48px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledText = styled(Text)`
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  @media(min-width: 767px) {
    font-size: 14px
    line-height: 18px;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const NotFoundIconContainer = styled.div`
  display: flex;
  width: 88px;
  height: 88px;
  padding: 16.5px 7.337px 0 7.333px;
  justify-content: center;
  align-items: center;
`;

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  // oopsie hardcoded data
  width: 430px;
  height: 240px;
  @media (max-width: 768px) {
    width: 100%;
    height: 60vh;
  }
`;

export const FindVehicleText = styled(Text)`
  color: #36354c;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const ReportNow = styled(Text)`
  color: #1b73e8;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;

export const FuelTypeText = styled.div`
  color: var(--Neutral-N400, #5b5675);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const IconContainer = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 2.667px 4.053px 2.167px 4.667px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;